module.exports = __webpack_public_path__ + "img/dark-mud-decal-29.ecde5971.png";